export interface OddsPreferencePopupState {
    counter: number;
    disabled: boolean;
}

export const defaultOddsPreferencePopupState: OddsPreferencePopupState = {
    counter: 0,
    disabled: false,
};
